<template>
  <v-menu
    v-model="value"
    class="no-print"
    transition="slide-y-transition"
    :close-on-content-click="false"
    :nudge-width="200"
    :nudge-right="200"
    :nudge-top="-15"
    offset-y
    offset-x
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" class="mr-1" small v-bind="attrs" v-on="on">
        <div class="body-2 mr-2" v-if="currentUserInfo">
          {{ currentUserInfo.firstname }} {{ currentUserInfo.lastname }}
        </div>
        <v-avatar size="32">
          <v-img src="@/assets/male_profile.svg" alt="profile image"></v-img>
        </v-avatar>
      </v-btn>
    </template>

    <v-card v-if="currentUserInfo">
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-img src="@/assets/male_profile.svg" alt="profile image" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              >{{ currentUserInfo.firstname }}
              {{ currentUserInfo.lastname }}</v-list-item-title
            >
            <v-list-item-subtitle>{{ roleName }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-row justify="center">
        <v-btn color="primary" class="mt-1 mb-2" small @click.stop="logout">
          <v-icon small left>mdi-logout</v-icon>
          ออกจากระบบ
        </v-btn>
      </v-row>
    </v-card>
    <v-card v-else>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>กรุณาเข้าสู่ระบบ</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-row justify="center">
        <v-btn color="primary" class="mt-1 mb-2" small @click.stop="logout">
          <v-icon small left>mdi-logout</v-icon>
          เข้าสู่ระบบ
        </v-btn>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import Auth from "../../common/firebase.auth";

const roleNameFilter = name => {
  switch (name) {
    case "School Admin":
      return "ผู้ดูแลโรงเรียน";
    case "Director":
      return "ผู้บริหาร";
    case "Super Admin":
      return "ผู้ดูแลระบบ";
    case "Teacher":
      return "คุณครู";
    case "Assistant Teacher":
      return "ครูพี่เลี้ยง";
    default:
      return "ผู้ใช้งานทั่วไป";
  }
};

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["currentUser", "currentUserInfo", "currentRoles"]),
    roleName() {
      let names = this.currentRoles.map(name => {
        return roleNameFilter(name);
      });

      return names.join(", ");
    }
  },
  mounted() {},
  methods: {
    async logout() {
      await Auth.signOut();
      this.$store.dispatch("logout");
      this.$router.push("/login");
    }
  }
};
</script>
